var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 119,
    viewBox: "0 0 156 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8319 51.5216L26.5259 30.2408C25.1809 26.3232 27.2665 22.0569 31.1841 20.7119L87.9329 1.22911C91.8507 -0.115935 96.1168 1.9697 97.4618 5.88735L104.768 27.1681L133.142 17.4267C137.06 16.0817 141.326 18.1673 142.671 22.085L176.766 121.395C178.111 125.313 176.026 129.579 172.108 130.924L44.4231 174.761C40.5055 176.106 36.2392 174.02 34.8942 170.102L0.799297 70.7919C-0.545697 66.8743 1.53989 62.608 5.45754 61.263L33.8319 51.5216ZM36.9046 129.764L46.646 158.138L160.144 119.172L150.402 90.798L36.9046 129.764ZM76.8184 84.3418L81.6891 98.529L95.8763 93.6583L91.0056 79.4711L76.8184 84.3418ZM43.1484 32.4637L48.0191 46.6509L90.5807 32.0388L85.71 17.8516L43.1484 32.4637Z",
    fill: "#5C6C8A",
    fillOpacity: 0.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsIcon2);
export default __webpack_public_path__ + "static/media/stats_icon2.afca897dc7a3574c41c670abc00b5b25.svg";
export { ForwardRef as ReactComponent };